export const SET_SEARCH_WIDGET_CONFIG = 'SET_SEARCH_WIDGET_CONFIG';

export function setSearchWidgetConfig(config) {
  return {
    type: SET_SEARCH_WIDGET_CONFIG,
    payload: config
  };
}
